import { toast as sonnerToast } from "sonner";

export const toast = {
  success: (message, options) =>
    sonnerToast.success(message, {
      ...options,
    }),

  error: (message, options) =>
    sonnerToast.error(message, {
      ...options,
    }),

  info: (message, options) =>
    sonnerToast.info(message, {
      ...options,
    }),

  warning: (message, options) =>
    sonnerToast.warning(message, {
      ...options,
    }),

  loading: (message, options) =>
    sonnerToast.loading(message, {
      ...options,
    }),

  custom: (message, options) =>
    sonnerToast(message, {
      ...options,
    }),

  promise: (promise, options) =>
    sonnerToast.promise(promise, {
      ...options,
    }),

  dismiss: sonnerToast.dismiss,
  message: sonnerToast.message,
};
